import { TransferRefundType } from "@edaz/utils/bankAccount/types";
import RefundPaymentType from "../entities/refundPaymentType";

export function refundPaymentTypeToTransferRefundType(refundPaymentType: RefundPaymentType): TransferRefundType | undefined {
  switch (refundPaymentType) {
    case RefundPaymentType.DomesticTransfer:
      return TransferRefundType.DOMESTIC;

    case RefundPaymentType.ForeignTransfer:
      return TransferRefundType.FOREIGN;

    case RefundPaymentType.SepaTransfer:
      return TransferRefundType.SEPA;

    case RefundPaymentType.PayGate:
    default:
      return undefined;
  }
}

export function transferRefundTypeToRefundPaymentType(transferRefundType: TransferRefundType): RefundPaymentType {
  switch (transferRefundType) {
    case TransferRefundType.DOMESTIC:
      return RefundPaymentType.DomesticTransfer;
    case TransferRefundType.FOREIGN:
      return RefundPaymentType.ForeignTransfer;
    case TransferRefundType.SEPA:
      return RefundPaymentType.SepaTransfer;
  }
}
